import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { baseURL } from "../utils/config";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function ForgotPasswordPage() {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [showInput, setShowInput] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) {
      Swal.fire({
        title: "Erreur",
        text: "Veuillez saisir votre email.",
        icon: "error",
        toast: true,
        position: 'top-right',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${baseURL}/password-reset-request/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email_or_telephone: inputValue }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || res.statusText || 'Erreur inconnue');

      Swal.fire({
        title: data.message,
        icon: "success",
        toast: true,
        timer: 2000,
        position: 'top-right',
        timerProgressBar: true,
        showConfirmButton: false,
      });

      setInputValue('');
    } catch (err) {
      Swal.fire({
        title: err.message || 'Une erreur est survenue.',
        icon: "error",
        toast: true,
        timer: 3000,
        position: 'top-right',
        timerProgressBar: true,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      <section className="d-flex align-items-start justify-content-center px-3" style={{ paddingTop: '100px', minHeight: 'calc(100vh - 60px)' }}>
        <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '1rem', animation: 'fadeInUp 0.6s ease' }}>
          <div className="text-center mb-4">
            <h3 className="fw-bold" style={{ color: '#004080' }}>Mot de passe oublié</h3>
            <p className="text-secondary mt-2 mb-0">Entrez votre email  pour recevoir un lien de réinitialisation.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-3 position-relative">
              <input
                type={showInput ? 'text' : 'email'}
                placeholder="Email "
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="form-control"
                required
              />
              <span
                onClick={() => setShowInput(!showInput)}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
              >
                {showInput ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" disabled={loading} className="btn w-100 fw-bold" style={{ backgroundColor: '#004080', color: 'white' }}>
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
          </form>
        </div>
      </section>

      <style>{`
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        input.form-control:focus, button:focus { box-shadow: 0 0 0 0.25rem rgba(0, 64, 128, 0.5); outline: none; transition: box-shadow 0.3s ease; }
      `}</style>
    </div>
  );
}

export default ForgotPasswordPage;
